import {
  _findOrderList,
  _findProduct,
  _findPayType,
  _addRemark,
  _payRefund,
  _findOrderLog,
  _getRenewQRCode,
  _getPurchaseQRCode,
} from '@/api/Online'
import {
  catchErr
} from '@/utils/utils'
import {
  Message
} from 'element-ui'

export default {

  // 获取纪念堂列表
  async findOrderList({
    commit,
    state
  }) {

    let paramsAll = {}
    let params = {}

    if (state.onlineOrder.onlineSearchForm.date != null && state.onlineOrder.onlineSearchForm.date.length >= 2) {
      params.payTimeStart = state.onlineOrder.onlineSearchForm.date[0];
      params.payTimeEnd = state.onlineOrder.onlineSearchForm.date[1];
    }
    params.code = state.onlineOrder.onlineSearchForm.code;
    params.deadManCode = state.onlineOrder.onlineSearchForm.deadManCode;
    params.userTel = state.onlineOrder.onlineSearchForm.userTel;
    if (state.onlineOrder.onlineSearchForm.productId != 0) {
      params.productId = state.onlineOrder.onlineSearchForm.productId;
    }
    // if (state.onlineOrder.onlineSearchForm.payType != 0) {
    //   params.payType = state.onlineOrder.onlineSearchForm.payType;
    // }
    if(state.onlineOrder.onlineSearchForm.status != -1) {
      params.status = state.onlineOrder.onlineSearchForm.status
    }

    // if(state.onlineOrder.onlineSearchForm.remark != ""){
    //   params.remark = state.onlineOrder.onlineSearchForm.remark
    // }

    if (state.onlineOrder.onlineSearchForm.dateBack != null && state.onlineOrder.onlineSearchForm.dateBack.length >= 2) {
      params.refundTimeStart = state.onlineOrder.onlineSearchForm.dateBack[0];
      params.refundTimeEnd = state.onlineOrder.onlineSearchForm.dateBack[1];
    }

    if (state.onlineOrder.title == 0) {
      params.productCategory = 1
    } else if (state.onlineOrder.title == 1) {
      params.productCategory = 2
    }

    paramsAll.data = params;

    if (state.onlineOrder.title == 0) {
      paramsAll.pageInfo = state.onlineOrder.pageManagement
    } else if (state.onlineOrder.title == 1) {
      paramsAll.pageInfo = state.onlineOrder.pageManagementV

    }
    
    let [err, res] = await catchErr(_findOrderList(paramsAll));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      console.log(res)
      if (res.data == undefined || res.data.length == 0) {
        state.onlineOrder.number = '0条';
        commit('SETORDERALLIST', [])
      } else {
        state.onlineOrder.number = res.pageInfo.total + '条';
        res.data.forEach((_t) => {
          let kt = _t.status - 0;
          switch (kt) {
            case 0:
              _t.statusName = '待付款';
              _t.payTime = '—'
              break;
            case 1:
              _t.statusName = '已完成';
              break;
            case 2:
              _t.statusName = '已退款';
              break;
            case 3:
              _t.statusName = '已失效';
              _t.payTime = '—'
              break;
            case 4:
              _t.statusName = '退款中';
              break;
            case 5:
              _t.statusName = '退款失败';
              break;
            default:
          }
          if(_t.userTel == undefined){
            _t.userTel = '—'
          }
          if(_t.deadManCode == undefined){
            _t.deadManCode = '—'
          }
          if(_t.deadManName == undefined){
            _t.deadManName = '—'
          }
          if(_t.refundTime == undefined){
            _t.refundTime = '—'
          }
          if(_t.remark == undefined){
            _t.remark = '—'
          }
          if(_t.refundRemark == undefined){
            _t.refundRemark = '—'
          }
        });
        commit('SETORDERALLIST', res.data)
      }
      if (state.onlineOrder.title == 0) {
        commit('SETPAGEMANAGEMENTORDERAALL', res.pageInfo)
      } else if (state.onlineOrder.title == 1) {
        commit('SETPAGEMANAGEMENTORDERAALLV', res.pageInfo)
      } else {
        commit('SETPAGEMANAGEMENTORDERAALL', res.pageInfo)
      }
    }
    return true;
  },

  // 获取商品列表
  async findProduct({
    commit,
    state
  }, params) {
    let [err, res] = await catchErr(_findProduct());
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      console.log(res)
      commit('SETFINDPRODUCT', res.data)
    }
    return true;
  },

  // 获取支付方式列表
  async findPayType({
    commit,
    state
  }, params) {
    let [err, res] = await catchErr(_findPayType());
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      console.log(res)
      commit('SETFINDPAYTYPE', res.data)
    }
    return true;
  },


  // 添加订单备注
  async addRemark({
    commit,
    state
  }, params) {
    let [err, res] = await catchErr(_addRemark({
      data: params
    }));
    if (err) {
      Message.error(err.message || '系统异常');
      return false
    } else if (res) {
      console.log(res)
      return res;
    }
    return true;
  },

  // 添加订单备注
  async payRefund({
    commit,
    state
  }, params) {
    let [err, res] = await catchErr(_payRefund({
      data: params
    }));
    if (err) {
      //Message.error(err.message || '系统异常');
      return err
    } else if (res) {
      console.log(res)
      return res;
    }
    return true;
  },

  // 日志列表
  async findOrderLog({
    commit,
    state,
    dispatch
  }, params) {
    params.createUserName = state.onlineOrder.onlineSearchFormLog.createUserName;
    params.content = state.onlineOrder.onlineSearchFormLog.content;
    if (state.onlineOrder.onlineSearchFormLog.date != null && state.onlineOrder.onlineSearchFormLog.date.length >= 2) {
      params.createDateStart = state.onlineOrder.onlineSearchFormLog.date[0];
      params.createDateEnd = state.onlineOrder.onlineSearchFormLog.date[1];
    }
    let [err, res] = await catchErr(_findOrderLog({
      data: params,
      pageInfo: state.onlineOrder.pageManagementLog
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      console.log(res)
      if (res.data == undefined || res.data.length == 0) {
        state.onlineOrder.numberLog = '0条';
        commit('SETLOGLIST', [])
        commit('SETPAGEMANAGEMENTLOG', res.pageInfo)
      } else {
        state.onlineOrder.numberLog = res.pageInfo.total + '条';
        commit('SETLOGLIST', res.data)
        commit('SETPAGEMANAGEMENTLOG', res.pageInfo)
      }
    }
    return true;
  },

  // 获取续费纪念堂二维码
  async getRenewQRCode({
    commit,
    state
  }, params) {
    let [err, res] = await catchErr(_getRenewQRCode({
      data: params
    }));
    if (err) {
      if(err.status == 1076){
        return err
      }
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
    return true;
  },

  // 获取购买纪念堂二维码
  async getPurchaseQRCode({
    commit,
    state
  }) {
    let [err, res] = await catchErr(_getPurchaseQRCode());
    if (err) {
      Message.error(err.message || '系统异常');
      return err;
    } else if (res) {
      return res;
    }
    return true;
  },

}



// WEBPACK FOOTER //
// ./src/store/modules/OnlineOrder/actions.js